var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-reports-status"},[_c('em',{staticClass:"page-reports-status__text",class:_vm.className,domProps:{"textContent":_vm._s(_vm.$tf(_vm.status))}}),(_vm.isDownloadLinkVisible)?_vm._t("download-link"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }